import React from 'react';
import { FaCheck } from 'react-icons/fa';
import './ProfileWizard.css'; 

const ProfileWizard = ({ currentStep, steps, onStepClick }) => {
    const totalSteps = steps.length;
    const progressPercent = totalSteps > 1 ? (currentStep / (totalSteps - 1)) * 100 : 0;

    return (
        <div 
            className="wizard-container candidate-profile-wizard"
            style={{ '--total-steps': totalSteps }}
        >
            <div className="step-indicator-wrapper">
                <div className="step-progress-track">
                    <div 
                        className="step-progress-fill" 
                        style={{ width: `${progressPercent}%` }}
                    ></div>
                </div>
                {steps.map((step, index) => (
                    <div 
                        key={step.id} 
                        className={`step-item ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                        onClick={() => onStepClick && onStepClick(index)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="step-circle">{index < currentStep ? <FaCheck /> : index + 1}</div>
                        <div className="step-label">{step.title}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProfileWizard;